import {
    CollectionConstituentProductsMap,
    DefaultCollectionProductMap
} from "./products";

export const validatePrimaryCollectionProduct = (
    productKey: string,
    primaryCollectionProduct: string | undefined | null
) => {
    const defaultCollectionProduct = DefaultCollectionProductMap[productKey];

    if (defaultCollectionProduct) {
        const isValidCollectionProduct =
            primaryCollectionProduct &&
            CollectionConstituentProductsMap[productKey] &&
            Object.values(
                CollectionConstituentProductsMap[productKey]
            ).includes(primaryCollectionProduct);

        return isValidCollectionProduct
            ? primaryCollectionProduct
            : defaultCollectionProduct;
    }

    return "";
};
